import { configureStore } from '@reduxjs/toolkit';
import invitationReducers from './state/invitation/reducers';
import lobbyReducers from './state/lobby/reducers';
import roundReducers from './state/round/reducers';
import userReducers from './state/user/reducers';

export const store = configureStore({
  reducer: {
    user: userReducers,
    round: roundReducers,
    invitation: invitationReducers,
    lobby: lobbyReducers,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
